import { render, staticRenderFns } from "./stepUi.vue?vue&type=template&id=3de8133c&scoped=true&"
import script from "./stepUi.vue?vue&type=script&lang=js&"
export * from "./stepUi.vue?vue&type=script&lang=js&"
import style0 from "./stepUi.vue?vue&type=style&index=0&id=3de8133c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de8133c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de8133c')) {
      api.createRecord('3de8133c', component.options)
    } else {
      api.reload('3de8133c', component.options)
    }
    module.hot.accept("./stepUi.vue?vue&type=template&id=3de8133c&scoped=true&", function () {
      api.rerender('3de8133c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/patrolTemplate/resultRecordType/stepUi.vue"
export default component.exports